import AppClip from './AppClip'

export default AppClip
